export default "__VITE_ASSET__BVsWhvKb__"